<hpf-point-of-interest-form
        *ngIf="pointOfInterest"
        [pointOfInterest]="pointOfInterest"
        (create)="onCreate($event)"
    ></hpf-point-of-interest-form>
<div *ngIf="!pointOfInterest" class="my-5 text-center">
    <nz-spin nzSimple></nz-spin>
</div>